// import React, { useEffect, useState } from "react";

const Header: React.FC = () => {

  // const [ form, setForm ] = useState()

  // useEffect(() => {
  //   setForm((window as any)?.KEW?.collections?.membership_form[0]?.url)
  // }, [])

  return (
    <>
      <header>
        <div className="row">
          <div className="columns large-12">
            <a href="http://www.kew.org/">
              <span className="kew-logo">
                <img src="/assets/default/images/kew-logo.svg" alt="Royal Botanic Gardens, Kew"/>
              </span>
            </a>
          </div>
        </div>
      </header>
      {/* { form === 'kew-membership' &&
        <div className="limited-offer">
          <div className="row">
            <p><span>Limited time offer</span> &mdash; sign up by Direct Debit and claim a free welcome gift!</p>
          </div>
        </div>
      } */}
    </>
  );
};

export default Header;